module.exports = __webpack_public_path__ + "static/img/ekolanding.11e5b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ekolanding.png
// module id = GNLr
// module chunks = 0